import { Box } from '@chakra-ui/react';
import Image from './Image';
import Link from './Link';
import { Location } from '../types';

const StaticMap = ({
  city,
  country,
  lat,
  lng,
  post_code,
  street_name,
  street_number,
}: Location) => (
  <Box width="100%">
    <Link
      href={`https://www.google.com/maps/search/?api=1&query=${[
        street_number,
        street_name,
        city,
        post_code,
        country,
      ]
        .filter(Boolean)
        .join('+')}`}
    >
      <Image
        src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&scale=2&size=640x350&
markers=color:0x007744|${lat},${lng}&key=${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}`}
        width="636"
        height="341"
        quality="90"
      />
    </Link>
  </Box>
);

export default StaticMap;
